import { ReferenceFilter } from '@/Data/typesV2'
import { getReferenceDataClass as getDataClass } from '@/utils/CRUD/read/reference'

/**
 * Resolves the data class for an entity by its name.
 * Used as a fallback when entity configuration is not available.
 */
export const getDataClassByEntityName = (entityName: string) => {
  const dataClassName = entityName.charAt(0).toUpperCase() + entityName.slice(1)
  try {
    return getDataClass(dataClassName)
  } catch (e) {
    console.error(`Failed to get data class for entity ${entityName}:`, e)
    return null
  }
}

/**
 * Resolves the data class for a referenced entity using referenceTo and optional filter.
 */
export const getDataClassByReference = (
  referenceTo: string,
  referenceFilter?: ReferenceFilter,
) => {
  try {
    return getDataClass(referenceTo, referenceFilter)
  } catch (e) {
    console.error(
      `Failed to get data class for referenced entity ${referenceTo}:`,
      e,
    )
    return null
  }
}
